import React from 'react';
import { connect } from 'react-redux';
import Chart from 'react-apexcharts';
import moment from 'moment';

const RiskDistribution = (props) => {
  return (
    <div className="card2 card2--line-chart card2--pie-chart">
      <p className="card2--line-chart__title" style={{ marginBottom: '0' }}>
        Patients by Risk
      </p>
      <p
        style={{
          fontSize: '1.4rem',
          marginBottom: '1.8rem',
          opacity: '0.5',
        }}
      >
        Based on latest assesments
      </p>
      <Chart
        options={{
          chart: {
            toolbar: {
              show: false,
            },
            fontFamily: 'IBM Plex Sans, sans-serif',
          },
          labels: ['Low LHI', 'Medium LHI', 'High LHI'],
          colors: ['#3ee866', '#ffcf5d', '#f85353'],
          plotOptions: {
            pie: {
              donut: {
                size: '55%',
                labels: {
                  show: true,
                  value: {
                    show: true,
                    formatter: (value) => value,
                  },
                  total: {
                    show: true,
                    label: 'Patients',
                  },
                },
              },
            },
          },
          legend: {
            show: true,
            showForSingleSeries: true,
            showForNullSeries: true,
            position: 'bottom',
            verticalAlign: 'middle',
            fontSize: '13px',
            markers: {
              width: '18px',
              height: '8px',
            },
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        }}
        series={[
          props.lowRiskCount,
          props.mediumRiskCount,
          props.highRiskCount,
        ]}
        type="donut"
        height={'90%'}
      />
      <p
        style={{
          fontSize: '1.4rem',
          textAlign: 'center',
          marginTop: '1rem',
        }}
      >{`As of: ${moment().format('DD-MM-YYYY hh:mm a')}`}</p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  lowRiskCount: state.analytics.lowRiskCount,
  mediumRiskCount: state.analytics.mediumRiskCount,
  highRiskCount: state.analytics.highRiskCount,
});

export default connect(mapStateToProps)(RiskDistribution);
